import { render } from "./CadastroProdutosConsultaView.vue?vue&type=template&id=7821c08c"
import script from "./CadastroProdutosConsultaView.vue?vue&type=script&lang=js"
export * from "./CadastroProdutosConsultaView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__